<table class="task">
  <!-- Task content -->
  <tr>
    <td class="question">
      <ng-katex-paragraph  [paragraph]="question.text | exerciseFormat:'text'"></ng-katex-paragraph >
    </td>
  </tr>
  <tr>
    <td class="number">{{ qIndex + 1 }}.</td>
    <td class="task_text">
      <div class="input-group big active">
        <span class="cross" *ngIf="isAuthorCard && isAccessCard" (click)="clearAnswer($event)">x</span>
        <input
          type="text"
          name=""
          [(ngModel)]="answerStr"
          [disabled]="!isAuthorCard || !isAccessCard"
          (ngModelChange)="answerInputChange($event)"
          [ngClass]="{'true': checkQuestionAnswer(), 'false': !checkQuestionAnswer(), 'empty': isEmptyAnswer(false)}"
        >
      </div>
    </td>
  </tr>
  <tr *ngIf="isAuthorCard && isAccessCard">
    <td class="answer-vars">
      <span *ngFor="let word of exercise.words" (click)="addWord(word.word)">{{ word.word }}</span>
    </td>
  </tr>
</table>
